import { ANALYZE_EVENT } from '@/utils/constant/analyze'

const WEB_SEARCH = {
  computed: {
    uid () {
      return this.$cookies.get('userid')
    }
  },
  methods: {
    sensorTrackHead (route, eventType, val, chooseVal) {
      if (!route) return
      const { name, path } = route
      // console.log(111, path, eventType, val, chooseVal)
      let location
      switch (name) {
        case 'lang':
          location = '直播页面'
          break
      }
      if (location) {
        this.sensorTrack(location, eventType, val, chooseVal)
      } else {
        this.sensorTrack(path, eventType, val, chooseVal)
      }
    },
    sensorTrack (location, eventType, val, chooseVal) {
      if (!location || !eventType) return
      // 2023/11/22添加 神策 埋点事件
      let type
      if (eventType === 'focus' && !val) {
        type = 0
      } else if (eventType === 'focus' && val) {
        type = 1
      } else if (eventType === 'click') {
        type = 2
      }
      const sType = this.searchType(type)
      this.$sensors.$setTrack(ANALYZE_EVENT.WEB_SEARCH, {
        location,
        type: sType,
        content: eventType === 'click' ? val : chooseVal,
        userid: this.uid
      })
    },
    searchType (type) {
      switch (type) {
        case 0:
          return '智能搜索列表'
        case 1:
          return '搜索联想'
        case 2:
          return '搜索'
      }
    }
  }
}

const WEB_DOWNLOAD = {
  computed: {
    uid () {
      return this.$cookies.get('userid')
    }
  },
  methods: {
    sensorTrackDownload (route) {
      if (!route) return
      const { name, path } = route
      // console.log(111, path)
      let location
      switch (name) {
        case 'lang':
          location = '直播页面'
          break
      }
      if (location) {
        this.sensorTrack(location)
      } else {
        this.sensorTrack(path)
      }
    },
    sensorTrack (location) {
      this.$sensors.$setTrack(ANALYZE_EVENT.WEB_DOWNLOAD, {
        location,
        userid: this.uid
      })
    }
  }
}

export {
  WEB_SEARCH,
  WEB_DOWNLOAD
}
